// window._ = require('lodash');
import Proper from 'popper.js';
import jquery from 'jquery';
// import 'bootstrap';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';

window.Popper = Proper;
window.$ = window.jQuery = jquery;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.dataListDirective = {
  inserted(el, binding) {
    const listValues = binding.value;
    const randomKey =
      'datalist-' +
      Math.random()
        .toString(36)
        .substring(7);
    let dataList = document.createElement('datalist');
    dataList.setAttribute('id', randomKey);
    el.setAttribute('list', randomKey);

    for (let listValue of listValues) {
      let option = document.createElement('option');

      if (typeof listValue === 'object') {
        // ラベル付きの場合

        if (listValue.label) {
          option.label = listValue.label;
        }
        option.id = listValue.id;
        option.value = listValue.value;
      } else {
        option.value = listValue;
      }

      dataList.appendChild(option);
    }

    document.querySelector('body').appendChild(dataList);
  },
};

window.addEventListener('DOMContentLoaded', function() {
  /*------------------------- 二度押し防止 -------------------------*/
  var form = document.querySelector('#submit_double');
  if (form) {
    form.dataset.submit_flug = false;
    form.addEventListener('submit', function(e) {
      let target = e.currentTarget;
      if (target.dataset.submit_flug == 'false') {
        target.dataset.submit_flug = 'true';
      } else {
        alert('只今処理中です。\nそのままお待ちください。');
        e.preventDefault();
      }
    });
  }

  // /*------------------------- ラジオボタンの切り替えリスナー -------------------------*/

  // var radios = document.querySelectorAll("form input[type='radio']");
  // var nowVal = '';
  // for (let index = 0; index < radios.length; index++) {
  //   const radio = radios[index];
  //   radio.addEventListener('click', function(e) {
  //     var element = e.currentTarget;
  //     if (nowVal == element.value) {
  //       element.checked = false;
  //     } else {
  //       nowVal = element.value;
  //     }
  //   });
  // }

  /*------------------------- 画像が無いときの代替画像差し込み処理 -------------------------*/

  var imgs = document.querySelectorAll('img');
  if (imgs.length > 0) {
    imgs.forEach(img => {
      img.addEventListener('error', function(e) {
        e.currentTarget.src =
          location.protocol +
          '//' +
          location.host +
          '/img/retail_hrd_default_image.png';
      });
    });
  }
});
